import Axios from "axios";
import {useMutation, useQueryClient} from "react-query";

export default function useSaveOrderKind() {
  const queryClient = useQueryClient();
  return useMutation((params) => Axios.post("/api/order-kinds/", params.orderKind), {
    onError: (_, params) => {
      params.setStatus({success: false, error: true});
    },
    onSuccess: (response, params) => {
      params.orderType.orderKinds.push(response.data);
      queryClient.invalidateQueries(["orderTypes"]);
      params.setStatus({success: true, error: false});
    },
  });
}
